import { useRef } from "react";
import { Modal, Table } from "react-bootstrap";
import Logo from "../../../../../assets/imgs/logo-azul.svg";
import "./style.css";

const Ticket = ({ show, onHide, data }) => {
  const printRef = useRef();

  const printTicket = () => {
    const printContent = printRef.current;
    if (!printContent) return;

    const printWindow = window.open("", "_blank", "width=800,height=1000");
    if (!printWindow) {
      alert("Por favor, permite las ventanas emergentes.");
      return;
    }

    // Estilos para impresión full-page (cero márgenes, tamaño exacto)
    const printStyles = `
    <style>
      /* Estilos generales */
      * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }

      body {
        font-family: 'Courier New', monospace, 'Segoe UI', sans-serif;
        font-size: 12px;
        line-height: 1.3;
        color: #000;
        background: #fff;
        /* Forzar impresión de colores y fondos */
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }

      /* Ajuste principal: el contenedor del ticket */
      .print-container {
        width: 100%;
        min-height: 100vh;
        padding: 0 !important;
        margin: 0 !important;
      }

      /* Estilo del ticket: ajustar ancho según necesidad */
      .ticket {
        width: 100%;
        max-width: none !important;
        margin: 0 !important;
        padding: 15px 10px !important;
        border: none !important;
        background: white !important;
        page-break-inside: avoid;
      }

      /* Tablas: bordes visibles al imprimir */
      table {
        width: 100%;
        border-collapse: collapse !important;
        margin: 8px 0;
      }
      th, td {
        border: 1px solid black !important;
        padding: 6px 4px !important;
        text-align: center;
        font-size: 12px;
      }
      th {
        background-color: #030c41 !important;
        color: white !important;
      }

      hr {
        border: 0;
        border-top: 1px dashed #000;
        margin: 8px 0;
      }

      img {
        max-width: 100%;
        height: auto;
      }

      /* Eliminar márgenes de impresión del navegador */
      @page {
        size: auto; /* o usa '80mm 300mm' para ticket térmico */
        margin: 0 !important;
      }

      @media print {
        html, body {
          width: 100%;
          height: 100%;
          margin: 0 !important;
          padding: 0 !important;
          overflow: hidden;
        }
        .print-container {
          height: auto;
          min-height: unset;
        }
      }
    </style>
  `;

    // Bootstrap CSS (solo si necesitas clases como 'text-center', 'fw-bold', etc.)
    // Si no lo usas, puedes quitarlo para hacerlo más ligero
    const bootstrapCDN = `
    <link 
      href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" 
      rel="stylesheet"
      integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH"
      crossorigin="anonymous"
    >
  `;

    const printDocument = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8">
        <title>Ticket</title>
        ${bootstrapCDN}
        ${printStyles}
      </head>
      <body>
        <div class="print-container">
          <div class="ticket">
            ${printContent.innerHTML}
          </div>
        </div>
        <script>
          window.onload = () => {
            setTimeout(() => {
              window.print();
              window.onafterprint = () => window.close();
            }, 300);
          };
        </script>
      </body>
    </html>
  `;

    printWindow.document.open();
    printWindow.document.write(printDocument);
    printWindow.document.close();
  };

  return (
    <Modal show={show} onHide={onHide} className="ticket-Modal" centered>
      <Modal.Header
        closeButton
        style={{ background: "#020C41", color: "white" }}
      >
        <Modal.Title>Ticket de cotización</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div ref={printRef} id="cubiTicket" style={{ padding: "25px" }}>
          <div
            className="ticket border p-4"
            style={{ width: "100%", margin: "0 auto" }}
          >
            {/* LOGO */}
            <p className="text-center">
              <img src={Logo} alt="LOGO" width="50%" />
            </p>

            <hr />

            <div className="text-center">
              <p>Aerovias de México S.A. de C.V.</p>
              <p>AME880912I89</p>
              <p>Col Cuauhtemoc C.P. 06500 Ciudad de México</p>
              <p>Paseo de la Reforma 243 Piso 25</p>
            </div>

            <hr />

            {/* DATOS DE MASTER */}
            <Table bordered size="sm">
              <thead>
                <tr>
                  <th
                    style={{
                      backgroundColor: "#030c41",
                      color: "white",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Cargo
                  </th>
                  <th
                    style={{
                      backgroundColor: "#030c41",
                      color: "white",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Importe
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    className="text-left"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Manejo de carga
                  </td>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderLeft: "none",
                      borderRight: "none",
                    }}
                  >
                    {data.amount_handling}
                  </td>
                </tr>

                <tr>
                  <td
                    className="text-left"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Refrigeración
                  </td>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderLeft: "none",
                      borderRight: "none",
                    }}
                  >
                    {data.amount_refri}
                  </td>
                </tr>

                <tr>
                  <td
                    className="text-left"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Congelación
                  </td>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    {data.amount_conge}
                  </td>
                </tr>
                <tr>
                  <td
                    className="text-left"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Screening
                  </td>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    {data.amount_screening}
                  </td>
                </tr>
                <tr>
                  <td
                    className="text-left"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    DG Fee
                  </td>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    {data.amount_dg}
                  </td>
                </tr>
                <tr>
                  <td
                    className="text-left"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Manejo por valor
                  </td>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    {data.amount_custom_value}
                  </td>
                </tr>
                <tr>
                  <td
                    className="text-left"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Fleje y empaque
                  </td>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    {data.amount_strap_pack}
                  </td>
                </tr>
                <tr>
                  <td
                    className="text-left"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Animales vivos
                  </td>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    {data.amount_avi}
                  </td>
                </tr>
                <tr>
                  <td
                    className="text-left"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    DG exentas
                  </td>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    {data.amount_dg_exempt}
                  </td>
                </tr>
                <tr>
                  <td
                    className="text-left"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Manejo RH
                  </td>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    {data.amount_hum}
                  </td>
                </tr>
                <tr>
                  <td
                    className="text-left"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Hielo seco
                  </td>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    {data.amount_ice}
                  </td>
                </tr>
                <tr>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Subtotal
                  </td>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    {data.subtotal}
                  </td>
                </tr>
                <tr>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    I.V.A.
                  </td>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    {data.iva}
                  </td>
                </tr>
                <tr>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Total
                  </td>
                  <td
                    className="text-right"
                    style={{
                      width: "50%",
                      padding: "4px 0",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    {data.total}
                  </td>
                </tr>
              </tbody>
            </Table>

            <hr />

            {/* MENSAJE FINAL */}
            <p className="mt-3 mgss text-uppercase text-justify">
              <small>({data.amount_word}/ 100 M.N. )</small>
            </p>

            <div className="mt-2">
              <hr />
              <p className="mt-3 fw-bold mgss text-justify">
                Este documento es una estimación conforme a los datos que usted
                ingresó.
              </p>
              <p className="mt-3 fw-bold mgss text-justify">
                El cálculo que se presenta está en función de nuestra tarifa
                pública.
              </p>
              <p className="mt-3 fw-bold mgss text-justify">
                La cotización puede variar en función del peso, valor de aduana
                y manejo especial que pueda requerir su embarque al momento de
                ingresarse al almacén.
              </p>
              <p className="mt-3 fw-bold mgss text-justify">
                * Precios sujetos a cambio sin previo aviso.
              </p>
            </div>
          </div>
        </div>

        <div className="text-end mt-4">
          <button className="btnn" onClick={() => printTicket("cubiTicket")}>
            Imprimir
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Ticket;
